import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {selectDefaultLocationId} from '@/app/store/config/selectors';
import {LocationPoint} from '@/common/interfaces/location';

export const fetchDefaultLocationInfoAction = createAsyncThunk<{language: string}, LocationPoint, void>(
	'config/fetchDefaultLocationInfo',
	async ({language}, {context, getState, success}) => {
		const defaultLocationId = selectDefaultLocationId(getState())!;
		const {getByIds} = context.backendAPI.location;
		const [location] = await getByIds([defaultLocationId], language, ['title', 'description']);
		return success(location);
	},
);
